import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BlogListPresenter } from './blog-list-presenter'
import { GetBlogsSearchParams } from '../../lib/types'
import { blogServices } from '../../services/blog-service'

const DEFAULT_LIMIT = 10
const DEFAULT_SEARCH_PARAMS: GetBlogsSearchParams = {
  limit: DEFAULT_LIMIT.toString(),
  offset: '0',
  keyword: '',
  sortBy: 'NEWEST_TO_OLDEST',
  status: undefined,
  category: undefined,
}
const DEFAULT_PAGINATION = {
  total: 0,
  limit: DEFAULT_LIMIT,
  count: 0,
  offset: 0,
}

function BlogListContainer() {
  const navigate = useNavigate()
  const [blogs, setBlogs] = useState<any[]>([])
  const [searchParams, setSearchParams] = useState<GetBlogsSearchParams>(DEFAULT_SEARCH_PARAMS)
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    const fetchBlogs = async () => {
      const data = await blogServices.getBlogs(searchParams)
      if (data?.blogs && data.blogs.length > 0) {
        setBlogs(data.blogs)
        setPagination(data.pagination)
      } else {
        setBlogs([])
        setPagination(DEFAULT_PAGINATION)
      }
    }
    fetchBlogs()
  }, [currentPage, searchParams])

  const handleSearchParams = async ({ name, value }: { name: string; value: string }) => {
    const { limit } = DEFAULT_PAGINATION
    setSearchParams((prev) => ({
      ...prev,
      offset: '0',
      limit: limit.toString(),
      [name]: value,
    }))
    setCurrentPage(1)
    setPagination(DEFAULT_PAGINATION)
  }
  const resetSearchParams = async () => {
    setSearchParams(DEFAULT_SEARCH_PARAMS)
  }
  const handleCurrentPage = (currentPage: number) => {
    const { limit } = DEFAULT_PAGINATION
    setCurrentPage(currentPage)
    setSearchParams((prev) => ({
      ...prev,
      offset: `${(currentPage - 1) * limit}`,
    }))
    setPagination((prev) => ({ ...prev, offset: (currentPage - 1) * limit }))
  }

  const handleBlogEdit = (id: number) => {
    navigate(`/blogs/${id}/edit`)
  }

  return (
    <BlogListPresenter
      pagination={pagination}
      handleCurrentPage={handleCurrentPage}
      currentPage={currentPage}
      resetSearchParams={resetSearchParams}
      searchParams={searchParams}
      handleSearchParams={handleSearchParams}
      handleBlogEdit={handleBlogEdit}
      blogs={blogs}
    />
  )
}

export { BlogListContainer }
